import { ESubscriptionProductCode } from "../types/subscription";

export const PAID_SUBSCRIPTION_CODES = new Set<string>([
  ESubscriptionProductCode.PRO,
  ESubscriptionProductCode.BUSINESS,
  ESubscriptionProductCode.ENTERPRISE,
]);
